import type { InfiniteData } from "@tanstack/react-query";
import type { ContentHubItem, ContentHubPage } from "./types";

/**
 * Flatten an infinite query's pages into a single newest-first list, deduped by
 * publishId. Dedup matters because an event updated mid-walk can shift between
 * pages (the server re-sorts on occurs_at) and briefly appear on two loaded
 * pages — we keep the first (newest-page) occurrence.
 */
export function flattenContentHubPages(
  data: InfiniteData<ContentHubPage> | undefined
): ContentHubItem[] {
  if (!data) return [];
  const seen = new Set<string>();
  const items: ContentHubItem[] = [];
  for (const page of data.pages) {
    for (const item of page.items) {
      if (seen.has(item.publishId)) continue;
      seen.add(item.publishId);
      items.push(item);
    }
  }
  return items;
}
